exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit_wrap[data-v-fe97ea02]{width:1050px;margin:50px auto;border:1px solid #eee}.link_a[data-v-fe97ea02]{border-bottom:1px solid red}.bor_style[data-v-fe97ea02]:not(:last-child){margin-left:-18px;margin-right:-18px;border-bottom:1px solid #eadadd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-fe97ea02","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/info_manage/brand_supple_agree/supple_skan_brand.vue
// module id = 434
// module chunks = 0